export default "__VITE_ASSET__j8U0k3qX__"